import React, { useState, useEffect } from 'react';
import { hapticFeedback } from '../../utils/haptics'; // Corrected import path
// No Icon import is needed as this component does not use it.

const ParentalGate = ({ isOpen, onSuccess, onClose }) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [answer, setAnswer] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;

      // Generate two random numbers between 10 and 19 for a simple sum.
      setNum1(Math.floor(Math.random() * 10) + 10);
      setNum2(Math.floor(Math.random() * 10) + 10);
      setAnswer('');
      setError('');

    // Prevent background scrolling
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // Handle escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
    }
    };

    document.addEventListener('keydown', handleEscape);
    
    // CRITICAL CLEANUP - Prevents button timeout issues
    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener('keydown', handleEscape);
      
      // Force cleanup any lingering active states
      setTimeout(() => {
        const activeElements = document.querySelectorAll('[aria-expanded="true"]');
        activeElements.forEach(el => el.setAttribute('aria-expanded', 'false'));
        
        // Remove any stuck focus states
        const focusedElements = document.querySelectorAll(':focus');
        focusedElements.forEach(el => el.blur());
      }, 100);
    };
  }, [isOpen, onClose]);

  const handleSubmit = () => {
    if (parseInt(answer) === num1 + num2) {
      onSuccess();
    } else {
      setError('Incorrect. Please try again.');
      hapticFeedback('error');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 text-center w-full max-w-sm">
        <h2 className="text-xl font-bold mb-2">Are you a grown-up?</h2>
        <p className="text-gray-600 mb-4">Please solve this problem to continue.</p>
        <p className="text-3xl font-extrabold text-blue-600 mb-4">{num1} + {num2} = ?</p>
        <input
          type="number"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          className="w-full text-center p-3 text-2xl border-2 border-gray-300 rounded-lg mb-2"
        />
        {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
        <div className="space-y-3 mt-4">
          <button onClick={handleSubmit} className="w-full bg-green-500 text-white font-bold py-3 px-6 rounded-xl shadow-lg">
            Continue
          </button>
          <button onClick={onClose} className="w-full bg-gray-200 text-gray-800 font-bold py-3 px-6 min-h-[44px] rounded-xl">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParentalGate;
